import React from "react";
import { NavLink } from "react-router-dom";
import { DAI_BASE_PATH } from "../constants";

const LINKS = [
  { to: "", label: "\u25CF Silver Dashboard" },
  { to: "silver/history", label: "\uD83D\uDCCA Silver History Avg" },
  { to: "gold", label: "\u25C6 Gold GDO Monitoring" },
  { to: "gold/reference", label: "\u2699 Gold Reference & Schedule" },
  { to: "iberia", label: "\uD83C\uDDEA\uD83C\uDDF8 Iberia Pipeline Status" },
  { to: "asset-tagging", label: "\uD83C\uDFF7 Asset Tagging" },
];

const EXTERNAL_LINKS = [
  {
    href: "https://adb-3737455747089122.2.azuredatabricks.net/dashboardsv3/01f11ebe2ac01e52a05b50020892095c/published/pages/bf2adc68?o=3737455747089122",
    label: "\uD83D\uDCC8 Pipeline Heartbeat",
  },
  {
    href: "https://adb-3737455747089122.2.azuredatabricks.net/dashboardsv3/01f0c08c267014ab8b256c004a8c52a0/published/pages/6cb274b7?o=3737455747089122",
    label: "\uD83D\uDEE1 Pipeline Assurance",
  },
];

export default function Nav() {
  return (
    <nav className="page-nav">
      {LINKS.map((l) => (
        <NavLink
          key={l.to || "root"}
          to={l.to ? `${DAI_BASE_PATH}/${l.to}` : DAI_BASE_PATH}
          end
          className={({ isActive }) => (isActive ? "active" : "")}
        >
          {l.label}
        </NavLink>
      ))}
      {EXTERNAL_LINKS.map((l) => (
        <a key={l.href} href={l.href} target="_blank" rel="noopener noreferrer">{l.label}</a>
      ))}
    </nav>
  );
}
